import React from 'react';

import Layout from '../components/Layout';

const Terms = () => (
  <Layout>
    Terms and services
  </Layout>
);

export default Terms;
